

export class GeoFenceAlertSpecificationOutput implements IGeoFenceAlertSpecificationOutput {
    /** The auto-generated id of the geofence master */
    geofence_id!: number;

    constructor(data?: IGeoFenceAlertSpecificationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geofence_id = _data["geofence_id"];
        }
    }

    static fromJS(data: any): GeoFenceAlertSpecificationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GeoFenceAlertSpecificationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geofence_id"] = this.geofence_id;
        return data; 
    }
}

export interface IGeoFenceAlertSpecificationOutput {
    /** The auto-generated id of the geofence master */
    geofence_id: number;
}

